import "./index.css";

const Loader = () => {
  return (
    <div className="loading-container">
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
